<template>
  <div class="sidebar__dropdowns dropdowns">
    <div
        :id="id(item.name)"
        class="dropdowns__item"
        v-for="(item, inx) in storeItems"
        :key="item.id"
    >
      <dropdown-item
          :dropdown-id="id(item.name)"
          :dropdown="item"
          :inx="inx"
          @result="result"
      />
    </div>
  </div>
</template>

<script>
import dropdownItem from '../components/dropdownItem.vue';

export default {
  name: "dropdown",
  components: {
    dropdownItem,
  },
  data() {
    return {
      Accordion: {
        count: 0,
        active: null
      }
    };
  },
  provide() {
    return { Accordion: this.Accordion };
  },
  computed: {
    storeItems() {
      return this.$store.getters.storeItems;
    },
  },
  methods: {
    id(itemName) {
      return itemName.toLowerCase().split(' ').join('-');
    },
    result(value) {
      this.$emit('result', value);
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.dropdowns {
  //flex-grow: 1;
  margin-bottom: 14px;

  @include up-tablet {
    margin-bottom: 21px;
  }

  @include up-laptop {
    margin-bottom: 34px;
  }
}
</style>
